import { useDispatch } from "react-redux";
import fetchServer from "../controllers/fetchServer";
import { setTrainings } from "../redux/reducers/settings/academySettingSlice";
import { enqueueSnackbar } from "notistack";

export default function useAcademy() {
  const dispatch = useDispatch();

  const getTrainings = async (setLoading) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "GET",
      url: `/main/v1/training`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            dispatch(setTrainings(res?.data?.data?.data));
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Something went wrong. please try again later.",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const getTrainingModule = async (
    setLoading,
    id,
    limit,
    offset
  ) => {
    try {
      if (setLoading) setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/main/v1/trainingModule?filterBy=training&filterValue=${id}&limit=${limit}&offset=${offset}`,
      });

      if (res && (res.status === 200 || res.status === 201)) {
        const responseData = res?.data?.data;
        return responseData;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. Please try again later.",
          { variant: "error" }
        );
        return null;
      }
    } catch (err) {
      enqueueSnackbar("Server error. Please try again later.", {
        variant: "error",
      });
      return null;
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  const getTrainingVideos = async (setLoading, id) => {
    try {
      if (setLoading) setLoading(true);

      const res = await fetchServer({
        method: "GET",
        url: `/main/v1/trainingVideo?filterBy=trainingModule&filterValue=${id}`,
      });

      if (res && (res.status === 200 || res.status === 201)) {
        const responseData = res?.data?.data?.data;
        return responseData;
      } else {
        enqueueSnackbar(
          res?.data?.message || "Something went wrong. Please try again later.",
          { variant: "error" }
        );
        return null;
      }
    } catch (err) {
      enqueueSnackbar("Server error. Please try again later.", {
        variant: "error",
      });
      return null;
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  const toggleAcademy = async (setLoading, id, resource, toggleName) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "PATCH",
      url: `/main/v1/${resource}/${id}/${toggleName}`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                "Training feature status toggled successfully!",
              {
                variant: "success",
              }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Failed to delete training. please try again",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const deleteAcademy = async (setLoading, id, resource) => {
    setLoading && setLoading(true);

    await fetchServer({
      method: "DELETE",
      url: `/main/v1/${resource}/${id}`,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message || "Training Module deleted successfully!",
              {
                variant: "success",
              }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                "Failed to delete training. please try again .",
              {
                variant: "error",
              }
            );
          }
        }
      })
      .catch((err) => {});

    setLoading && setLoading(false);
  };

  const saveTraining = async (
    setLoading,
    payload,
    id = null,
    method = "POST"
  ) => {
    setLoading && setLoading(true);

    await fetchServer({
      method,
      url: id ? `/main/v1/training/${id}` : `/main/v1/training`,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Training updated successfully!"
                  : "Training created successfully!"),
              { variant: "success" }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Failed to update Training!"
                  : "Failed to create Training!"),
              { variant: "error" }
            );
          }
        }
      })
      .catch((err) => {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      });

    setLoading && setLoading(false);
  };

  const saveTrainingVideo = async (
    setLoading,
    payload,
    id = null,
    method = "POST"
  ) => {
    setLoading && setLoading(true);

    await fetchServer({
      method,
      url: id ? `/main/v1/trainingVideo/${id}` : `/main/v1/trainingVideo`,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Training video updated successfully!"
                  : "Training video created successfully!"),
              { variant: "success" }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Failed to update training video!"
                  : "Failed to create training video!"),
              { variant: "error" }
            );
          }
        }
      })
      .catch(() => {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      });

    setLoading && setLoading(false);
  };

  const saveModule = async (
    setLoading,
    payload,
    id = null,
    method = "POST"
  ) => {
    setLoading && setLoading(true);

    await fetchServer({
      method,
      url: id ? `/main/v1/trainingModule/${id}` : `/main/v1/trainingModule`,
      data: payload,
    })
      .then((res) => {
        if (res) {
          if (res.status === 200 || res.status === 201) {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Training module updated successfully!"
                  : "Training module created successfully!"),
              { variant: "success" }
            );
          } else {
            enqueueSnackbar(
              res?.data?.message ||
                (id
                  ? "Failed to update training module!"
                  : "Failed to create training module!"),
              { variant: "error" }
            );
          }
        }
      })
      .catch(() => {
        enqueueSnackbar("Something went wrong!", { variant: "error" });
      });

    setLoading && setLoading(false);
  };

  return {
    getTrainings,
    toggleAcademy,
    deleteAcademy,
    saveTraining,
    saveModule,
    getTrainingModule,
    getTrainingVideos,
    saveTrainingVideo,
  };
}
